export default "__VITE_ASSET__BL_HPank__"